import React from 'react';
import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';
import { View } from 'react-native';

import { IconTouchable } from '../../common/IconTouchable';
import { Separator } from '../../common/Separator';
import type { IVideoPlayerStore } from './VideoPlayer';
import { selectPlayIcon } from './videoPlayerUtils';

const Container = styled(View)({
  flexDirection: 'row',
});

const NoIconView = styled(View)({
  size: 40,
});

export interface IMobilePlayerControlProps {
  store: IVideoPlayerStore;
  onTogglePlay(): void;
  onNextVideo(): void;
  onPreviousVideo(): void;
  hasNextVideoButton: boolean;
  hasPreviousVideoButton: boolean;
}

export const MobilePlayerControl =
  observer<IMobilePlayerControlProps>(
    ({
      store,
      onTogglePlay,
      onPreviousVideo,
      onNextVideo,
      hasPreviousVideoButton,
      hasNextVideoButton,
    }) => {
      const playButtonIconName = selectPlayIcon({
        isPlaying: store.isPlaying,
        isFinished: store.isFinished,
      });

      return (
        <Container>
          {hasPreviousVideoButton ? (
            <IconTouchable
              name="previous-bold"
              color="$background0"
              onPress={onPreviousVideo}
              size={40}
            />
          ) : (
            <NoIconView />
          )}
          <Separator size="$14" vertical />

          {!store.isLoading ? (
            <IconTouchable
              name={playButtonIconName}
              color="$background0"
              onPress={onTogglePlay}
              size={40}
            />
          ) : (
            <NoIconView />
          )}

          <Separator size="$14" vertical />
          {hasNextVideoButton ? (
            <IconTouchable
              name="next-bold"
              color="$background0"
              onPress={onNextVideo}
              size={40}
            />
          ) : (
            <NoIconView />
          )}
        </Container>
      );
    },
  );
